import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { PaginatedResponse } from "../../../core/http/paginated-response.type";
import { QueryParams } from "../../../core/http/query-params.type";
import { DEFAULT_QUERY_PARAMS } from "../../../shared/constants/services";
import { AnyObject } from "../../../shared/types/app.type";
import { UserInfo } from "../../../shared/types/user-info";
import { setEmptyStringsToNull } from "../../../shared/utils/objects/object";
import { MaintenanceProvider } from "./maintenance-provider.types";

@Injectable({
  providedIn: "root",
})
export class MaintenanceProviderService {
  basePath = `${environment.serverUrl}/maintenance-providers`;
  currentUser: UserInfo;
  basePathCsvQueue = `${this.basePath}/queue-csv`;

  constructor(private readonly http: HttpClient, private readonly authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  createMaintenanceProvider(values: AnyObject): Observable<MaintenanceProvider> {
    setEmptyStringsToNull(values);
    return this.http.post<MaintenanceProvider>(`${this.basePath}`, values).pipe(
      tap((_data: MaintenanceProvider) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  updateMaintenanceProvider(id: string, values: AnyObject): Observable<MaintenanceProvider> {
    setEmptyStringsToNull(values);
    return this.http.put<MaintenanceProvider>(`${this.basePath}/${id}`, values).pipe(
      tap((_data: MaintenanceProvider) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  getMaintenanceProviders(
    options?: QueryParams<MaintenanceProvider>,
  ): Observable<PaginatedResponse<MaintenanceProvider>> {
    let params: HttpParams = new HttpParams();

    for (const key in options) {
      if (options[key]) {
        params = params.set(key, JSON.stringify(options[key]));
      }
    }

    return this.http.get<PaginatedResponse<MaintenanceProvider>>(this.basePath, { params }).pipe(
      tap((_data) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  getMaintenanceProvider(id: string, options?: QueryParams<MaintenanceProvider>): Observable<MaintenanceProvider> {
    let params: HttpParams = new HttpParams();
    options = { ...DEFAULT_QUERY_PARAMS, ...options };
    for (const key in options) {
      if (options[key]) {
        params = params.set(key, JSON.stringify(options[key]));
      }
    }
    return this.http.get<MaintenanceProvider>(`${this.basePath}/${id}`, { params }).pipe(
      tap((_data) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  getMaintenanceProvidersQueue(options?: QueryParams<MaintenanceProvider>): Observable<void> {
    let params: HttpParams = new HttpParams();
    options = { ...DEFAULT_QUERY_PARAMS, ...options };
    for (const key in options) {
      if (options[key]) {
        params = params.set(key, JSON.stringify(options[key]));
      }
    }

    return this.http.get<void>(this.basePathCsvQueue, { params }).pipe(
      tap((_data) => console.log()),
      catchError(this.handleError<any>()),
    );
  }

  linkPartners(id: string, data): Observable<void> {
    return this.http.post<void>(`${this.basePath}/${id}/partners`, data).pipe(
      tap((_data) => console.log()),
      catchError(this.handleError<any>("linkPartners")),
    );
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return throwError(error);
    };
  }
}
